import React from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography, Avatar } from '@mui/material';

const IOSSwitch = styled(  ({ avatarSrc, count, expanded, ...other }) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...other} />
  )
)(({ theme, checked, avatarSrc, count, expanded }) => ({
  width: 50,
  height: 23,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 1,
    '&.Mui-checked': {
        transform: 'translateX(26px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: checked ? '#404585' : '#e7e7ff',
        opacity: 1,
        border: 0,
      },
    },
    '&.Mui-disabled': {
      '& .MuiSwitch-thumb': {
      },
      '& + .MuiSwitch-track': {
        opacity: 0.7,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: '#fff',
    width: 20,
    height: 20,
    position: 'relative',
    backgroundImage: avatarSrc ? `url(${avatarSrc})` : 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    '&:after, &:before': {
      content: `'${count}'`,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      fontWeight: 'bold',
      color: expanded ? '#8387BD' : '#8387BD',
      fontSize: '0.75rem', // Adjust the size as needed
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: 16,
    backgroundColor: checked ? '#404585' : '#f3f3fa',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const CustomSwitchWithCount = ({ count, expanded, toggleAccordion, avatarSrc = null }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
      <IOSSwitch checked={expanded} count={count} onChange={toggleAccordion} avatarSrc={avatarSrc} />
      {!expanded && (
      <ExpandMoreIcon
        onClick={toggleAccordion}
        style={{
          transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.3s',
          marginLeft:"-26px",
          cursor: 'pointer',
          height: "14px",
          color: expanded ? "white" :"#8287bd"
        }}
      />)}
    </div>
  );
};

export default CustomSwitchWithCount;
